import { reclamacionService } from '@/_services';

export const reclamacion = {
  namespaced: true,
  state: {
    current: null,
    cambioEstado: {},
    current_status: {}
  },
  actions: {
    getReclamacion({ commit }, reclamacionId) {
      commit('getReclamacionRequest');
      reclamacionService.getReclamacion(reclamacionId)
        .then(
          reclamacion => commit('getReclamacionSuccess', reclamacion),
          error => commit('getReclamacionFailure', error)
        );
    },
    marcarLeida({ commit }, reclamacion) {
      commit('cambioEstadoRequest');
      reclamacionService.marcarLeida(reclamacion)
        .then(
          reclamacion => commit('cambioEstadoSuccess'),
          error => commit('cambioEstadoFailure', error)
        );
    },
  },
  mutations: {
    cambioEstadoRequest(state) {
      state.cambioEstado = { loading: true };
    },
    cambioEstadoSuccess(state) {
      state.cambioEstado = { changed: true };
    },
    cambioEstadoFailure(state, error) {
      state.cambioEstado = { error };
    },
    getReclamacionRequest(state) {
      state.current = null;
      state.current_status = { loading: true };
    },
    getReclamacionSuccess(state, reclamacion) {
      state.current = reclamacion;
      state.current_status = { loaded: true };
    },
    getReclamacionFailure(state, error) {
      state.current = null;
      state.current_status = { error }
    },
  }
}
